import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const LandingAutocompleteOptionStyled = styled.li.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "landing-autocomplete-option",
  },
)`
  .landing-autocomplete-option__location {
    display: flex;
    width: 44px;
  }

  .landing-autocomplete-option__parts {
    width: calc(100% - 44px);
    word-wrap: break-word;
  }
`;
